export default __webpack_public_path__ + "static/media/pattarai-orientation.b334ee24.jpg";